{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "engagement",
  "x-cli-editable": true,
  "x-feature": true,
  "title": "Engagement",
  "description": "LLM-driven conversation elements: dynamic questions, context gathering, follow-up suggestions.",
  "type": "object",
  "properties": {
    "dynamic_questions": {
      "type": "object",
      "ui:description": "Dynamic starter questions shown to visitors",
      "properties": {
        "enabled": {
          "type": "boolean",
          "ui:description": "Enable dynamic question generation"
        },
        "number_of_questions": {
          "type": "integer",
          "ui:description": "Number of questions to display at the same time. 0 hides them.",
          "minimum": 0,
          "maximum": 10
        },
        "questions": {
          "type": "object",
          "ui:widget": "dynamic-questions",
          "ui:description": "Starter questions visitors see in the search bar",
          "additionalProperties": {
            "type": "object",
            "properties": {
              "default": {
                "type": "array",
                "ui:description": "Default questions shown on all pages",
                "maxItems": 30,
                "items": {
                  "type": "string",
                  "maxLength": 500,
                  "minLength": 1
                }
              },
              "pages": {
                "type": "array",
                "ui:description": "Page-specific question overrides (matched by URL pattern, first match wins).",
                "maxItems": 50,
                "items": {
                  "type": "object",
                  "properties": {
                    "patterns": {
                      "type": "array",
                      "ui:description": "URL patterns to match (glob syntax).",
                      "maxItems": 20,
                      "items": {
                        "type": "string"
                      }
                    },
                    "questions": {
                      "type": "array",
                      "ui:description": "Questions to show on matching pages",
                      "maxItems": 30,
                      "items": {
                        "type": "string",
                        "maxLength": 500,
                        "minLength": 1
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "suggested_answers": {
      "type": "object",
      "ui:title": "Context Gathering",
      "ui:description": "Controls how the agent gathers context before answering. Frequency sets how often the agent asks clarifying follow-up questions. Suggested answers are clickable response buttons shown to visitors to guide the conversation.",
      "properties": {
        "frequency": {
          "type": "string",
          "enum": [
            "never",
            "low",
            "moderate",
            "high",
            "very_high"
          ],
          "ui:widget": "slider",
          "ui:description": "How often the agent asks clarifying questions before answering. Never: always answers directly. Low: rarely asks. Moderate (default): asks when helpful. High: frequently asks. Very High: asks as much as needed.",
          "default": "moderate"
        },
        "enabled": {
          "type": "boolean",
          "ui:title": "Enable Suggested Answers",
          "ui:description": "Show clickable answer buttons below the agent's questions so visitors can respond with one tap instead of typing"
        },
        "rules": {
          "type": "string",
          "x-access": "staff",
          "ui:widget": "textarea",
          "ui:title": "Suggested Answers Rules",
          "ui:description": "Custom instructions for generating the clickable answer buttons. Example: if the agent asks 'What's your monthly traffic?', buttons could be: Under 5k | 5k-30k | 30k-100k | 100k+. Use rules like 'keep suggestions under 5 words' or 'always include a negative option'.",
          "ui:deprecation-notice": "Deprecated. New rules can no longer be added here — use the Qualification config instead, where each profiling field can declare its own answer options that are surfaced as suggested answers automatically. Existing rules remain editable so they can be migrated and cleared.",
          "maxLength": 2000
        }
      }
    },
    "followup_suggestions": {
      "type": "object",
      "x-tier": "advanced",
      "ui:description": "Follow-up question suggestions after agent responses",
      "properties": {
        "enabled": {
          "type": "boolean",
          "ui:description": "Enable follow-up suggestions"
        }
      }
    }
  },
  "default": {
    "dynamic_questions": {
      "enabled": true,
      "number_of_questions": 2,
      "questions": {
        "en": {
          "default": [
            "What does {{company_name}} do?",
            "Do you have case studies in my industry?",
            "How much does {{company_name}} cost?",
            "Which ROI can I expect?",
            "How long does it take to implement {{company_name}}?"
          ]
        },
        "fr": {
          "default": [
            "Quels sont les services proposés par {{company_name}} ?",
            "Avez-vous des cas clients dans mon secteur ?",
            "Combien coûte {{company_name}} ?",
            "À quel ROI puis-je m'attendre ?",
            "Combien de temps prend l'implémentation de {{company_name}} ?"
          ]
        }
      }
    },
    "suggested_answers": {
      "frequency": "moderate",
      "enabled": true
    },
    "followup_suggestions": {
      "enabled": true
    }
  }
}
